import IFrame from '.';
import { SupportedFonts } from '#constants';
import { Box, Stack, Theme, styled } from '@mui/material';
import { FC, CSSProperties } from 'react';

// Inner phone "screen" surface. Forces a new stacking context so the iframe's
// rendered content (e.g. the candidate portal's grey bottom-nav background) is
// clipped to the rounded corners — without isolation/mask-image WebKit lets
// iframe content bleed past the rounded clip.
const PhoneScreen = styled(Box)(({ theme }) => ({
  borderRadius: '40px',
  maxHeight: '100%',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.contrast,
  WebkitMaskImage: '-webkit-radial-gradient(white, black)',
  isolation: 'isolate',
}));

type Props = {
  name: string;
  width?: CSSProperties['width'];
  font?: SupportedFonts;
  children?: React.ReactNode;
};

const MobileIframeContainer: FC<Props> = ({ children, name, width, font }) => {
  return (
    <Stack direction="row" justifyContent="center" height="100%" my={2.5}>
      <Box
        bgcolor={(theme: Theme) => theme.palette.common.black}
        borderRadius="45px"
        boxShadow={(theme: Theme) => theme.shadows[10]}
        p={1.25}
        height="736px"
        width="414px"
      >
        <PhoneScreen>
          <IFrame name={name} width={width} font={font}>
            {children}
          </IFrame>
        </PhoneScreen>
      </Box>
    </Stack>
  );
};

export default MobileIframeContainer;
